import { rem2px } from '@/views/activities/utils';

const u = (v) => rem2px(v, false);

export const INIT_ZINDEX = 32; // 拖拽元素初始z-index
export const MAX_ZINDEX = 100; // 最大层级，就是说拖拽元素不会超过MAX_ZINDEX

export const MARGIN = u(30); // 初始左右边距
export const SPACE = u(24); // 拖拽元素初始之间的间距

export const StatusEnum = {
  open: 0,
  close: 1
};

export function useWidths() {
  return {
    0: [u(88), u(88)],
    1: [u(100), u(120)],
    2: [u(124), u(136)],
    3: [u(236), u(172)]
  };
}

export function useDebounce(fn, delay) {
  return function() {
    clearTimeout(fn.id);
    fn.id = setTimeout(() => {
      fn.apply(this, arguments);
    }, delay);
  };
}

export function useSafeArea() {
  return {
    width: document.documentElement.clientWidth || document.body.clientWidth,
    height: document.documentElement.clientHeight || document.body.clientHeight,
    margin: u(30),
    bottom: u(56)
  };
}
